// extracted by mini-css-extract-plugin
module.exports = {"unresolved":"style__unresolved__9yNsr"};